import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import HeaderIcon from "./header-icon.svg";

export const OuterContainer = styled.div`
  padding: 1px;

  border-radius: 12px;

  background-image: linear-gradient(to right, #eb4254, #4585ff);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  inline-size: 100%;
  block-size: 100%;
  padding-block: 12px;
  padding-inline: 20px;

  border-radius: 12px;

  background-color: #ffffff;

  box-shadow:
    0 0 1px 0 #ffffff inset,
    0 0 1px 0 #ffffff;
`;

export const HeaderContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const BodyContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const StyledHeaderIcon = styled(HeaderIcon)`
  inline-size: 25px;
  block-size: 25px;
`;

const Placeholder = styled.div`
  block-size: 24px;

  background-color: #d9d9d9;

  animation: flash 1s linear infinite;

  @keyframes flash {
    0%,
    100% {
      opacity: 1;
    }
    50% {
      opacity: 0.6;
    }
  }
`;

export const TitlePlaceholder = styled(Placeholder)`
  inline-size: 166px;
`;

type BodyPlaceholderProps = {
  $size: number;
};

export const BodyPlaceholder = styled(Placeholder, { ...transientOptions })<BodyPlaceholderProps>`
  inline-size: ${({ $size }) => $size}px;
`;
